import { CODE_LANGUAGES } from '../constants/codeLanguages'

export function languageKeyFromMimeMode({ mode, mime }: Record<string, string>): string {
  const [selectedLanguageKey] =
    Object.entries(CODE_LANGUAGES).find(
      ([, value]) =>
        value.mime === mime &&
        // value.mode can be unset whereas $codeBlock.node.attrs.mode can be null, so we use eqeq here rather than being fancy
        // eslint-disable-next-line eqeqeq
        value.mode == mode,
    ) ?? Object.entries(CODE_LANGUAGES)[0]
  return selectedLanguageKey
}
